import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../login-unaware-component';
import { GraphClientService } from '../services/graph-client-service';
import { DateHelperService } from '../services/date-helper';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

const MAX_NUMBER_OF_ITEMS = 6;

/**
 * Displays list of announcements sourced from a SharePoint Online list.
 */
@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent extends LoginUnawareComponent implements OnInit {

  public announcements: any[];
  public sourceHasMoreItems: boolean;

  constructor(diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService,
    private dateHelper: DateHelperService) {
    super(diagnosticsFactory.create('AnnouncementsComponent'));
    this.announcements = [];
  }

  ngOnInit(): void {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const allItems = dynamicData.value as any[];
        allItems.sort((left, right) => left.fields.SortOrder - right.fields.SortOrder);

        if (allItems.length > MAX_NUMBER_OF_ITEMS) {
          console.log(`${this.constructor.name}: WARNING: The number of items returned by data service exceeds the ` +
            `max. value of ${ MAX_NUMBER_OF_ITEMS } items that can be displayed. The rest of the items are ignored.`);
          this.announcements = allItems.slice(0, MAX_NUMBER_OF_ITEMS);
          this.sourceHasMoreItems = true;
        } else {
          this.announcements = allItems;
          this.sourceHasMoreItems = false;
        }
      }, error => {
        this.diagnostics.logError(`ERROR loading data. Details: ${JSON.stringify(error)}`);
      });
  }

  public getTimeline(item: any): string {
    const rawStart = item.fields.StartDate;
    const rawEnd = item.fields.EndDate;
    return this.dateHelper.getTimeline(rawStart, rawEnd);
  }
}
